enum MobileEventShareStates {
    Sent = 1,
    Accepted = 2,
    Rejected = 3,
    Left = 4,
    Removed = 5,
    EventEnded = 6,
}
export default MobileEventShareStates;